import * as React from 'react';

interface ComponentContextState {
    [component: string]: React.ComponentType<any>;
}

interface ComponentProviderProps {
    components?: ComponentContextState;
}

const defaults = {
    Link: DefaultLink,
};

const ComponentContext = React.createContext<ComponentContextState>(defaults);

export const ComponentProvider: React.FunctionComponent<React.PropsWithChildren<ComponentProviderProps>> = (props) => {
    const { children, components = defaults } = props;

    const memoComponents = React.useMemo(() => components, [components]);

    return <ComponentContext.Provider value={memoComponents}>{children}</ComponentContext.Provider>;
};

export const useComponents = (): ComponentContextState => {
    const components = React.useContext(ComponentContext);
    return components;
};

// Helpers

export type DefaultLinkProps = React.PropsWithChildren<React.AnchorHTMLAttributes<HTMLAnchorElement>>;
function DefaultLink({ href, children, ...passThroughProps }: DefaultLinkProps) {
    return (
        <a href={href} {...passThroughProps}>
            {children}
        </a>
    );
}

DefaultLink.displayName = 'DefaultLink';
